// extracted by mini-css-extract-plugin
export default {"backgroundContainer":"style_backgroundContainer__YEwsQ"};